"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGetSessionStorageSuccessActionBase = void 0;
var actions_1 = require("../constants/actions");
var createGetSessionStorageSuccessActionBase = function (_a) {
    var sessionStorage = _a.sessionStorage, description = _a.description;
    return {
        description: description,
        type: actions_1.GET_SESSION_STORAGE_SUCCESS,
        sessionStorage: sessionStorage,
    };
};
exports.createGetSessionStorageSuccessActionBase = createGetSessionStorageSuccessActionBase;
